import utils from '@/libs/utils/utils'

export default {
  // 判断是否是来自app
  isFromApp() {
    return navigator.userAgent.indexOf('gofun') > -1
  },
  //判断是否来自H5用车
  isFromH5Car() {
    return Boolean(top.h5car)
  },
  /**
   * app中是否有dsBridge的注册事件
   */
  ishaveNativeMethod(funName) {
    return Boolean(dsBridge.hasNativeMethod(funName))
  },
  /**
   * try catch封装
   * @param fnTry
   * @param fnCatch
   */
  tryCatch(fnTry, fnCatch) {
    try {
      fnTry && fnTry()
    } catch (e) {
      console.info(e)
      fnCatch && fnCatch()
    }
  },
  //app关闭webView
  closeWebView() {
    if (this.ishaveNativeMethod('closed')) {
      dsBridge.call('closed')
    } else if (window.h5bridge && window.h5bridge.closed) {
      window.h5bridge.closed()
    } else if (window.updateSim && window.updateSim.closed) {
      window.updateSim.closed()
    }
  },
  //app回到首页(原toHomeRefreshFuction 方法合并到此方法)
  toHomeFuction() {
    if (this.ishaveNativeMethod('toHomeFuction')) {
      dsBridge.call('toHomeFuction')
    } else {
      this.tryCatch(() => {
        window.toHome.toHomeRefreshFuction()
      })
    }
  },

  /**
   * 回到首页立即用车tab
   */
  toHomeImmediately() {
    if (this.ishaveNativeMethod('toHomeImmediately')) {
      dsBridge.call('toHomeImmediately')
    } else {
      this.tryCatch(() => {
        window.toHome.toHomeImmediately()
      })
    }
  },

  // 跳转至app中的实名认证
  toAppAuth(vCardState, vLicenseState) {
    let params = {
      vCardState,
      vLicenseState
    }
    console.log('in toappauth', vCardState, vLicenseState);
    if (this.ishaveNativeMethod('toAppAuth')) {
      console.log('in toappauth if');
      dsBridge.call('toAppAuth', params)
    } else {
      console.log('in toappauth else');
      this.tryCatch(() => {
        window.h5bridge.toAppAuth(params)
      })
    }
  },

  /**
   * 增加右上角文字跳转
   * @param {*} text //文字
   * @param {*} url //跳转链接
   * @param {*} textColor //536版本增加参数，文字颜色
   * @param {*} callback // 点击按钮的回调
   */
  addHeadRightText(text, url, textColor, callback) {
    if (!text) {
      console.error('增加右上角文字', text, url)
      return
    }
    let params = {
      itemName: text,
    }
    if (url) {
      params.url = url
    }
    if (textColor) {
      params.textColor = textColor
    }
    if (this.ishaveNativeMethod('addRightText')) {
      if (callback && typeof callback === 'function') {
        dsBridge.call('addRightText', params, callback)
      } else {
        dsBridge.call('addRightText', params)
      }
    } else {
      this.tryCatch(() => {
        window.h5bridge.addRightText(text, url)
      })
    }
  },
  //移除右上角文字跳转
  removeHeadRightText() {
    if (this.ishaveNativeMethod('removeRightText')) {
      dsBridge.call('removeRightText')
    } else {
      this.tryCatch(() => {
        window.h5bridge.removeRightText()
      })
    }
  },
  //试乘试驾弹框
  jiXingSuccessToShare() {
    if (this.ishaveNativeMethod('jiXingSuccessToShare')) {
      dsBridge.call('jiXingSuccessToShare')
    }
  },
  //控制右上角小红点显示隐藏
  appGetRightIconVisibility(isVisibility) {
    const params = {isVisibility}
    if (this.ishaveNativeMethod('getRightIconVisibility')) {
      dsBridge.call('getRightIconVisibility', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.getRightIconVisibility(params)
      })
    }
  },
  //获取车务app的token
  getCheWuToken() {
    if (dsBridge) {
      let cheWu_token = dsBridge.call("getToken")
      if (cheWu_token) {
        sessionStorage.setItem('cheWu_token', cheWu_token)
        return cheWu_token
      }
    } else {
      return ''
    }
  },
  //App内打开一个新的网页
  appOpenUrl(url, shouldHideNavBar = false) {
    let params = {
      url,
      shouldHideNavBar
    }
    if (this.ishaveNativeMethod('openURL')) {
      dsBridge.call('openURL', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.openUrl(url)
      })
    }
  },
  /**
   * 调用点亮你的分享海报弹窗
   * @param fnCallBack 分享成功后的回调
   * @param shareLink 分享出去的url,用于给客户端生成二维码
   * 调dsBridge时传json对象{shareLink:shareLink,callback: callback}
   */
  lightCityShare(callback, shareLink) {
    let params = {
      shareLink,
      callback
    }
    if (this.ishaveNativeMethod('shareLightCityPoster')) {
      dsBridge.call('shareLightCityPoster', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.shareLightCityPoster(callback, shareLink)
      })
    }
  },
  /**
   * 更新当前token的手机号
   * @param newToken 新的token
   */
  updateUserToken(newToken) {
    if (this.ishaveNativeMethod('updateUserToken')) {
      dsBridge.call('updateUserToken', newToken)
    } else {
      this.tryCatch(() => {
        window.updateSim.updateUserToken(newToken)
      })
    }
  },
  /**
   * 获取数据上报信息
   */
  getReportInfo() {
    if (this.ishaveNativeMethod('getReportInfo')) {
      return dsBridge.call('getReportInfo')
    } else if (window.h5bridge && window.h5bridge.getReportInfo) {
      return window.h5bridge.getReportInfo()
    } else if (window.dataReport && window.dataReport.getReportInfo) {
      return window.dataReport.getReportInfo()
    } else {
      return "{}"
    }
  },
  /**
   * vue 完成加载时调用此方法
   */
  vueRouterDidFinishLoad() {
    if (this.ishaveNativeMethod('vueRouterDidFinishLoad')) {
      dsBridge.call('vueRouterDidFinishLoad')
    } else {
      this.tryCatch(() => {
        window.native && window.native.vueRouterDidFinishLoad()
      })
    }
  },
  /**
   * 选择问题上报图片
   * @param takePhotoHandler 拍照完成回调
   * @param maxImageCount 最多选择几个图片
   * @param selectPhotosHandler 选择图片完成时回调
   * 调用dsBridge时传json对象
   */
  selectReportPhotos(takePhotoHandler, selectPhotosHandler, maxImageCount) {
    if (this.ishaveNativeMethod('selectReportPhotos')) {
      let params = {
        takePhotoHandler,
        maxImageCount,
        selectPhotosHandler
      }
      dsBridge.call('selectReportPhotos', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.selectReportPhotos(takePhotoHandler, selectPhotosHandler, maxImageCount)
      })
    }
  },
  /**
   * 跳转优惠券详情地图
   * @param id 优惠券id
   */
  goToCouponDetail(id) {
    if (this.ishaveNativeMethod('couponDetail')) {
      dsBridge.call('couponDetail', id)
    } else {
      this.tryCatch(() => {
        window.h5bridge.couponDetail(id)
      })
    }
  },
  /**
   * 整租回传数据
   * @param url 跳转连接
   */
  rentGetUrlBroadcast(url) {
    if (this.ishaveNativeMethod('rentGetUrlBroadcast')) {
      dsBridge.call('rentGetUrlBroadcast', url)
    } else {
      this.tryCatch(() => {
        window.h5bridge.rentGetUrlBroadcast(url)
      })
    }
  },
  /**
   * 唤起三方地图导航
   * dsBridge参数 json对象，jsBridge四个参数
   * @param endLon:endLon, //目的地经度
   * @param endLat:endLat, //目的地维度
   * @param navType:navType //导航类型，0 步行，1 驾车
   * @param destinationName:destinationName //目的地名称
   * @param parkingId:parkingId //停车场Id
   * @param fromWholeRent //是否来自整租里的网点详情，整租的没有站内导航
   * }
   */
  navInMapApp(endLon, endLat, navType, destinationName, parkingId, fromWholeRent = false) {
    let params = {
      endLon,
      endLat,
      navType,
      destinationName,
      parkingId,
      fromWholeRent: fromWholeRent ? true : false,
    }
    if (this.ishaveNativeMethod('navInMapApp')) {
      dsBridge.call('navInMapApp', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.navInMapApp(endLon, endLat, navType, destinationName)
      })
    }
  },
  /**
   * 普通打开相机
   * @param requestId 请求id
   * @param callback 拍照完成回调
   */
  normalOpenCamera(requestId, callback) {
    let params = {
      requestId,
      callback
    }
    if (this.ishaveNativeMethod('openCamera')) {
      dsBridge.call('openCamera', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.openCameraWithRequestIdCallback(requestId, callback)
      })
    }
  },
  /**
   * 车损上报页面打开相机
   * @param position 车辆位置
   * @param callback 拍照完成回调
   */
  carDamageopenCamera(callback, position) {
    let params = {
      position,
      callback
    }
    if (this.ishaveNativeMethod('openCamera')) {
      dsBridge.call('openCamera', params)
    } else {
      this.tryCatch(() => {
        window.uploadCarDamage.openCamera(callback, position)
      })
    }
  },
  /**
   * 充值支付
   * @param id 充值 chargeId
   * @param cityCode 运营城市citycode
   */
  nativePay({chargeId, cityCode}) {
    if (this.ishaveNativeMethod('nativePay')) {
      const appVersion = utils.getAppVersion()
      console.log('appVersion: ', appVersion)
      console.log('chargeId: ', chargeId)
      console.log('cityCode: ', cityCode)
      if (appVersion < 5400) {
        console.log(11111)
        dsBridge.call('nativePay', chargeId)
      } else {
        console.log(22222)
        console.log({chargeId, cityCode})
        dsBridge.call('nativePay', {chargeId, cityCode})
      }
    } else {
      this.tryCatch(() => {
        window.pay.nativePay(chargeId)
      })
    }
  },
  /**
   * 去支付 dsBridge参数为一个json对象
   * @param payType 支付类型，2 支付宝，3 微信
   * @param orderInfo 订单信息，json 字符串
   * @param callback 支付完成回调
   * 注意：此bridge app没有处理支付宝免密支付逻辑
   */
  toPay(payType, orderInfo, callback) {
    let params = {
      payType,
      orderInfo,
      callback
    }
    if (this.ishaveNativeMethod('toPay')) {
      dsBridge.call('toPay', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.toPay(payType, orderInfo, callback)
      })
    }
  },
  /**
   * 查看网点详情图片 dsBridge参数为一个json对象
   * @param imageURLs 所以图片 URL 数组
   * @param selectedIndex 当前查看图片的下标 从0开始
   * @param canDownload是否可下载 0: 不可长按下载  1：可长按下载  不传 不可长按下载
   */
  openSlider(imageURLs, selectedIndex, canDownload) {
    let params = {
      imageURLs,
      selectedIndex,
      canDownload
    }
    if (this.ishaveNativeMethod('openSlider')) {
      dsBridge.call('openSlider', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.openSlider(imageURLs, selectedIndex)
      })
    }
  },
  /**
   * 导航栏添加分享按钮 dsBridge参数为一个json对象
   * @param title 分享标题
   * @param desc 分享描述
   * @param link 分享链接
   * @param wxShareImgUrl 分享图标
   */
  addShareBtn(params) {
    let {title, desc, link, wxShareImgUrl} = params
    if (!title || !desc || !link) {
      return console.log('缺少分享参数')
    }
    if (this.ishaveNativeMethod('addRightText')) {
      dsBridge.call('addRightText', {itemName: '分享'}, function () {
        dsBridge.call('wxShare', params)
      })
    } else {
      this.tryCatch(() => {
        // if (/Android (\d+\.\d+)/.test(navigator.userAgent)){
        if (navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("Adr") > -1) {
          window.share.addShareBtn(title, desc, link)
        } else {
          window.h5bridge.showShareNavWithTitleDescLink(title, desc, link)
        }
      })
    }
  },
  /**
   * 唤起微信分享弹窗 dsBridge参数为一个json对象
   * 原先 wxShareWithTitleDescLink 改为此方法
   * @param title 分享标题
   * @param desc 分享描述
   * @param link 分享链接
   * @param wxShareImgUrl 分享图标
   */
  openWxShare(title, desc, link, wxShareImgUrl) {
    let params = {
      title,
      desc,
      link,
      wxShareImgUrl,
    }
    if (this.ishaveNativeMethod('wxShare')) {
      dsBridge.call('wxShare', params)
    } else if (window.h5bridge && window.h5bridge.wxShareWithTitleDescLink) {
      let uAgent = navigator.userAgent;
      let isAndroid = uAgent.indexOf("Android") > -1 || uAgent.indexOf("Adr") > -1;  // android终端
      let isiOS = !!uAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  // iOS终端
      if (isAndroid) {
        window.h5bridge.wxShareWithTitleDescLink(title, link, desc)
        return
      }
      window.h5bridge.wxShareWithTitleDescLink(title, desc, link)
    }
  },

  /**
   * 分享图片到微信
   *
   * @param scene 分享方式 0 微信好友，1 朋友圈，Int
   * @param imageURL 图片链接
   * @param imageBase64 图片 base64 串
   * @param imageURL和imageBase64只需要传一个，两个同时存在时，使用imageURL
   */
  wxImageShare(scene, imageURL) {
    let params = {
      scene,
      imageURL
    };
    console.log('params: ', params)
    dsBridge.call('wxImageShare', params)
  },
  /**
   * 分享图片
   * @param image 图片url
   * @param callback 分享后的回调
   */
  wxShareWithImage(image, callback) {
    this.tryCatch(() => {
      if (this.ishaveNativeMethod('wxShareWithImage')) {
        dsBridge.call('wxShareWithImage', {image, callback})
      }
    })
  },
  /**
   * 唤起登录页面
   * @param callback 关闭登录页面回调方法名string
   */
  showLoginView(callback) {
    console.log('判断是否有showLoginViewbridge');
    if (this.ishaveNativeMethod('showLoginView')) {
      console.log('调用showLoginViewbridge');
      dsBridge.call('showLoginView', callback)
    } else {
      this.tryCatch(() => {
        window.native.showLoginView()
      })
    }
  },
  /**
   * 网页导航栏添加右边的 icon
   * @param iconUrl
   * @param callback
   */
  addRightIcon(iconUrl, callback) {
    if (this.ishaveNativeMethod('addRightIcon')) {
      dsBridge.call('addRightIcon', {itemImage: iconUrl}, callback)
    }
  },
  /**
   * 网页导航栏移除右边的icon
   */
  removeRightIcon() {
    console.log('removeRightIcon', this.ishaveNativeMethod('removeRightIcon'))
    if (this.ishaveNativeMethod('removeRightIcon')) {
      dsBridge.call('removeRightIcon')
    }
  },
  /**
   * 设置导航栏背景色
   * @param type 背景色类型，1 深色，2 浅色 int
   */
  setBackBg(type) {
    if (this.ishaveNativeMethod('setBackBg')) {
      dsBridge.call('setBackBg', type)
    } else {
      this.tryCatch(() => {
        window.h5bridge.setBackBg(type)
      })
    }
  },
  /**
   * 设置导航栏标题颜色 dsBridge参数为一个json对象
   * @param textColor 文字颜色，HEX 格式
   * @param bgColor 导航栏背景色，HEX 格式
   */
  setTitleColor(textColor, bgColor) {
    let params = {
      textColor,
      bgColor
    }
    if (this.ishaveNativeMethod('setTitleColor')) {
      dsBridge.call('setTitleColor', params)
    } else {
      this.tryCatch(() => {
        window.changeTitleBgColor.setTitleColor(textColor, bgColor)
      })
    }
  },
  /**
   *  设置导航栏默认标题颜色
   */
  setDefaultTitleColor() {
    if (this.ishaveNativeMethod('setDefaultTitleColor')) {
      dsBridge.call('setDefaultTitleColor')
    } else {
      this.tryCatch(() => {
        window.changeTitleBgColor.setDefaultTitleColor()
      })
    }
  },
  /**
   *  设置导航栏标题 dsBridge参数为一个json对象
   *  @param titleText 导航栏标题
   *  @param textColor 文字颜色，HEX 格式
   *  @param bgColor 导航栏背景色，HEX 格式
   */
  setTitleText(titleText, textColor, bgColor) {
    let params = {
      titleText,
      textColor,
      bgColor
    }
    if (this.ishaveNativeMethod('setTitleText')) {
      dsBridge.call('setTitleText', params)
    } else {
      this.tryCatch(() => {
        window.h5bridge.setTitleText(titleText, textColor, bgColor)
      })
    }
  },
  /**
   *  车损上报页面 预览图片 dsBridge参数为一个json对象
   *  @param position 车辆位置
   *  @param callback 拍照完成回调
   */
  previewImage(callback, position) {
    let params = {
      callback,
      position
    }
    if (this.ishaveNativeMethod('previewImage')) {
      dsBridge.call('previewImage', params)
    } else {
      this.tryCatch(() => {
        window.uploadCarDamage.previewImage(callback, position)
      })
    }
  },
  /**
   *  车损上报页面 下一步
   */
  pass() {
    if (this.ishaveNativeMethod('pass')) {
      dsBridge.call('pass')
    } else {
      this.tryCatch(() => {
        window.uploadCarDamage.pass()
      })
    }
  },
  /**
   *  车损上报页面 获取左下角提示信息
   */
  getText() {
    if (this.ishaveNativeMethod('getText')) {
      return dsBridge.call('getText')
    } else if (window.uploadCarDamage && window.uploadCarDamage.getText) {
      return window.uploadCarDamage.getText()
    }
  },
  /**
   *  个人中心文明用车分展示页面 改变网页展示高度
   *  @param height 网页的高度 int
   */
  changeHeight(height) {
    if (this.ishaveNativeMethod('changeHeight')) {
      dsBridge.call('changeHeight', height)
    } else {
      this.tryCatch(() => {
        window.h5bridge.changeHeight(height)
      })
    }
  },
  /**
   *  获取 jwt字符串 dsBridge参数为一个json对象
   *  @param secret 加密秘钥
   *  @param playload jwt的playload
   */
  getJwt(secret, playload) {
    let params = {
      secret,
      playload
    }
    if (this.ishaveNativeMethod('jwt')) {
      return dsBridge.call('jwt', params)
    } else {
      if (window.h5bridge && window.h5bridge.jwt) {
        return window.h5bridge.jwt(secret, playload)
      }
    }
  },
  /**
   * 订单完成领取完奖励 弹出评价框
   */
  orderRewardReceived(orderId) {
    if (this.ishaveNativeMethod('orderRewardReceived')) {
      dsBridge.call('orderRewardReceived', orderId)
    }
  },
  /**
   * 分享截图
   * @params type '0':当前页面截图 '1': 长截图
   */
  shareImageBySnapshot(type) {
    console.log('分享截图')
    if (this.ishaveNativeMethod('shareImageBySnapshot')) {
      console.log('有shareImageBySnapshot bridge')
      dsBridge.call('shareImageBySnapshot', {type})
    }
  },
  reloadEntireData() {
    if (this.ishaveNativeMethod('reloadEntireData')) {
      console.log('有reloadEntireData bridge')
      dsBridge.call('reloadEntireData')
    }
    console.log('reloadEntireData --- false');

  },
  /**
   * // 唤起IM
   * @param key
   */
  nativeIm(key) {
    if (this.ishaveNativeMethod('nativeIm')) {
      dsBridge.call('nativeIm', key)
    }
  },
  /**
   * // 跳转原生结单页面
   * @param key
   */
  freeReturnCarSuccess(key) {
    if (this.ishaveNativeMethod('freeReturnCarSuccess')) {
      dsBridge.call('freeReturnCarSuccess', {count: key})
    }
  },
  /**
   * // 浏览器打开链接
   * @param key
   */
  startAppWithSchema(url) {
    if (this.ishaveNativeMethod('startAppWithSchema')) {
      dsBridge.call('startAppWithSchema', url)
    }
  },
  /**
   * 跳转用车4步认证或保证金
   * param carId
   */
  toAuthentication(carId) {
    if (this.ishaveNativeMethod('toAuthentication')) {
      dsBridge.call('toAuthentication', carId)
    }
  },
    /**
     * 跳转用车4步认证或保证金
     * param carTypeId orderType
     */
    toAuthenticationForCarTypeId(carTypeId, orderType) {
        const params = {
            carTypeId,
            orderType
        }
        if (this.ishaveNativeMethod('toAuthenticationForCarTypeId')) {
            dsBridge.call('toAuthenticationForCarTypeId', params)
        }
    },
    /**
     * App跳小程序
     * params: obj
     *  g_id - 小程序原始id
     *  path - 拉起小程序页面的可带参路径，不填默认拉起小程序首页
     *  miniprogramType - int 可选打开 正式版:0，测试版:1，体验版:2
     */
    GFWXMiniProgram(params) {
        console.log('params: ', params)
        if (this.ishaveNativeMethod('GFWXMiniProgram')) {
            dsBridge.call('GFWXMiniProgram', params)
        }
    },
    /**
     * 分享微信图文（直接分享出去，不包括弹窗）-ios可以用 -安卓不支持
     * param: title: 标题
     * param: desc: 描述
     * param: link: 链接
     * param: wxShareImgUrl: 分享缩略图
     * param: scene: 好友0、朋友圈1 int
     */
    wxShareWithScene(title, desc, link, wxShareImgUrl, scene) {
        const params = {
            title,
            desc,
            link,
            wxShareImgUrl,
            scene
        }
        if (this.ishaveNativeMethod('wxShareWithScene')) {
            console.log('params: ', params)
            dsBridge.call('wxShareWithScene', params)
        }
    },
    /**
     * 打开GoFun App搜索
     * @param params
     * 入参 {
            latitude: '39.944465',
            longitude: '116.469542',
            funName: 'searchMapCb' window下挂的回调方法
        }
     * 返回值
     * {
            "latitude": 39.944767,
            "longitude": 116.469567,
            "poiAddress": "农展馆北路,枣营北里三十八号楼106号(首汽大厦对面)",
            "poiName": "街电(木北护肤造型)",
            "cityName": "北京市",
            "cityCode": "010",
            "adCode": "xxxxx"
        }
     */
    openGoFunSearchMap(params) {
        dsBridge.call('openGoFunSearchMap', params)
    },
    /**
     * 打开地图展示POI点
     * @param params
     入参 {
            latitude: '39.944465',
            longitude: '116.469542',
        }
     */
    examineGoFunMap(params) {
        // dsBridge.call('examineGoFunMap', {
        //     latitude: '39.944465',
        //     longitude: '116.469542',
        // });
        dsBridge.call('examineGoFunMap', params)
    },
    /**
     * 车务连续拍照bridge
     * param imageCount 拍照图片数量int
     */
    takeMultiPhotos(imageCount) {
        if (this.ishaveNativeMethod('takeMultiPhotos')) {
            dsBridge.call('takeMultiPhotos', imageCount )
        }
    },
    /**
     * 还车巡检，返回app还车巡检页面
     */
     pushToCheckCarVC(data) {
        if (this.ishaveNativeMethod('pushToCheckCarVC')) {
            dsBridge.call('pushToCheckCarVC', data )
        }
    },
    /**
     * 获取车务经纬度
     */
    getLatLng() {
        if (this.ishaveNativeMethod('getLatLng')) {
            return dsBridge.call('getLatLng')
        }
    },
    /**
     * 签名上传bridge
     * param data 传什么 app就接受什么 any
     */
     resultCallBack(data) {
      if (this.ishaveNativeMethod('resultCallBack')) {
          dsBridge.call('resultCallBack', data )
      }
    },
    /**
     * app登录和退出之后bridge
     * param app传回来的token
     */
    //  loginStateChanged(token) {
    //   if (this.ishaveNativeMethod('loginStateChanged')) {
    //       dsBridge.call('loginStateChanged', token )
    //   }
    // },
}



// WEBPACK FOOTER //
// src/libs/jsBridge.js